<!--
 * @Author: andy_chen
 * @created: 2018-11-13 15:57:46
-->

<template>
    <div class="container">
        <list-item title="消息通知设置" to="/pushSetting" :hasBottomLine="true" class="top-split-line"></list-item>

        <list-item title="账号与安全" to="/safeSetting" :hasBottomLine="true" class="top-split-line"></list-item>

        <!-- <list-item title="清理缓存" :msg="cache" :hasBottomLine="true" @click="handleClearCache"></list-item> -->
        <list-item title="关于我们" to="/aboutUs" :hasBottomLine="true" class="top-split-line"></list-item>

        <div class="logout-item border-bottom-line border-top-line" @click="handleLogout">退出登录</div>
    </div>
</template>

<script>
import ListItem from "../components/ListItem";
import nativeApi from "../nativeApi/index.js";
export default {
    name: "Setting",
    components: {
        ListItem
    },
    data() {
        return {
            cache: ""
        };
    },

    mounted() {},

    computed: {},

    methods: {
        handleClearCache() {
            this.$messageBox({
                type: "confirm",
                title: "确定清理缓存么？"
            }).then(result => {
                if (result === 1) {
                    this.$toast.open({ msg: "清理成功" });
                    this.cache = 0;
                }
            });
        },
        handleLogout() {
            this.$messageBox({
                type: "confirm",
                title: "退出登录后将无法收到任何互动信息"
            }).then(result => {
                if (result === 1) {
                    this.$store
                        .dispatch("FedLogOut")
                        .then(() => {
                            return nativeApi.logoutSuccess();
                        })
                        .then(res => {
                            // 退出是否成功
                            if (res.state === 0) {
                                this.$toast.open({ msg: "退出成功" });
                                setTimeout(() => {
                                    nativeApi.backToHome();
                                }, 1000);
                            } else {
                                this.$toast.open({ msg: res.message });
                            }
                        });
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
@import "../style/function.scss";
@import "../style/config.scss";

input {
    background: #ffffff;
    box-sizing: border-box;
    width: 100%;
    outline: none;
    border: none;
    // /*去除系统默认的样式*/
    -webkit-appearance: none;
    // /* 点击高亮的颜色*/
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.container {
    background: $baseBackgroundColor;
    align-items: flex-start;
}

.top-split-line {
    margin-top: 0.1rem;
}

.logout-item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1rem;
    font-size: 0.32rem;
    background: #ffffff;
    width: 100%;
    margin-top: 0.3rem;
    position: relative;
}
</style>
